var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compass-mount"},[_c('div',{ref:"chartSlot",staticClass:"compass-chart-slot"},[_c('Chart',{ref:"chart",staticClass:"diagram",style:({ cursor: _vm.cursor }),attrs:{"options":_vm.chartOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }